import React from "react";

export default function OfferLabel({ classes = "", text = "Extra Discount" }) {
  const getText = () => {
  if (text) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, 'text/html');
    const textContent = doc.body.textContent; 
    return textContent.trim(); 
  }
  return "Avail Offer";
}; 
  return (
    <div className={`limitedOfferLabel sofia-pro ${classes}`}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_3415_11293)">
          <path
            d="M6.74993 11.2498L11.2499 6.7498M2.99168 10.9948L1.85168 9.85481C1.38668 9.38981 1.38668 8.62481 1.85168 8.15981L2.99168 7.0198C3.18668 6.8248 3.34418 6.4423 3.34418 6.1723V4.5598C3.34418 3.8998 3.88418 3.3598 4.54418 3.3598H6.15668C6.42668 3.3598 6.80918 3.2023 7.00418 3.0073L8.14418 1.8673C8.60918 1.4023 9.37418 1.4023 9.83918 1.8673L10.9792 3.0073C11.1742 3.2023 11.5567 3.3598 11.8267 3.3598H13.4392C14.0992 3.3598 14.6392 3.8998 14.6392 4.5598V6.1723C14.6392 6.4423 14.7967 6.8248 14.9917 7.0198L16.1317 8.15981C16.5967 8.62481 16.5967 9.38981 16.1317 9.85481L14.9917 10.9948C14.7967 11.1898 14.6392 11.5723 14.6392 11.8423V13.4548C14.6392 14.1148 14.0992 14.6548 13.4392 14.6548H11.8267C11.5567 14.6548 11.1742 14.8123 10.9792 15.0073L9.83918 16.1473C9.37418 16.6123 8.60918 16.6123 8.14418 16.1473L7.00418 15.0073C6.80918 14.8123 6.42668 14.6548 6.15668 14.6548H4.54418C3.88418 14.6548 3.34418 14.1148 3.34418 13.4548V11.8423C3.34418 11.5648 3.18668 11.1823 2.99168 10.9948Z"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.8711 10.875H10.8778M7.12109 7.125H7.12709"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_3415_11293">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
      {/* Extra 35% Off */}
      <span>{getText()}</span>
    </div>
  );
}
